<!--
 * @Author: your name
 * @Date: 2021-10-29 15:42:35
 * @LastEditTime: 2021-11-16 17:51:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \adminCRM\src\components\customerCheck\customerLabel.vue
-->
<template>
<div id="customerCarInfo" class="container section-container">
    <div class="opretaBtn" v-if="!closableHandle">
      <div><h1>客户画像</h1></div>
      <div>
        <el-button type="primary" v-if="customerPortrait.length>0" @click="closableHandle = true">编辑</el-button>
        <el-button @click="addSelectLabel">添加</el-button>
      </div>
    </div>
    <div class="opretaBtn" v-else>
      <div><h1>客户画像</h1></div>
      <div>
        <el-button type="primary" @click="saveLable">保存</el-button>
        <el-button @click="cancelEdit">取消</el-button>
      </div>
    </div>
    <div v-for="(chunk,index) in customerPortrait" :key="index">
        <div class='tagTitle'>
          <el-tag type='info'  :closable="closableHandle" @close="reomveType(chunk)">
            {{chunk.groupName}}:
          </el-tag>
        </div>
        <el-tag :key="t" v-for="(tag,t) in chunk.corpTags" :disable-transitions="false" :closable="closableHandle" @close="reomveZiLabel(tag.tagId)">
            {{tag.tagName}}
        </el-tag>
    </div>
    <el-dialog title="添加标签" :visible.sync="labelVisible" width="900px">
        <div class="opretaBtn">
          <div><el-input placeholder="请输入标签分类/名称" @input="searchName" clearable style="width:210px" v-model="labelname"></el-input></div>
          <div>
            <el-button @click="addNewCancel">取 消</el-button>
            <el-button type="primary" @click="addNewSubmit">保 存</el-button>
          </div>
        </div>
        <div v-for="(chunk,ind1) in customerSelect" :key="ind1">
            <div class="tagTitle">{{chunk.groupName}}:</div>
            <el-checkbox-group v-model="checkedIds">
                <el-checkbox style="margin-bottom:8px;width:130px;" v-for="(tag,ind2) in chunk.corpTags" :checked="tag.isSelect === '1' ? true : false" :label="tag" :key="ind2" border size="small">{{tag.tagName}}</el-checkbox>
            </el-checkbox-group>
        </div>
    </el-dialog>
    <el-dialog title="是否确认删除" :visible.sync="deleteDialog" width="600px">
        <div>删除标签分类将会删除分类下所有标签，是否确认删除</div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="deleteDialog = false">取 消</el-button>
            <el-button type="primary" @click="deleteTypeHandle">保 存</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import http from '@/api/label';
export default {
  name: 'customer',
  props: ['mobile', 'update'],
  data () {
    return {
      checkedIds: [],
      isIndeterminate: true,
      customerPortrait: [],
      groupArr: [],
      deleteDialog: false,
      closableHandle: false,
      labelVisible: false,
      labelname: '',
      customerSelect: []
    };
  },
  watch: {
    'update' () {
      // 先格式化data
      this.getLabelList();
    }
  },
  created () {
    this.getLabelList();
  },
  methods: {
    getLabelList () {
      http.userLabelList({mobile: this.mobile}).then((res) => {
        if (res.success) {
          this.customerPortrait = res.data;
        }
      });
    },
    // 保存
    saveLable () {
      let ids = [];
      this.customerPortrait.map(child => {
        child.corpTags.map(item => {
          ids.push(item.tagId);
        });
      });
      const params = {
        tagIds: ids,
        mobile: this.mobile
      };
      http.addUserLabelSave(params).then((res) => {
        if (res.success) {
          this.closableHandle = false;
          this.$message.success('操作成功!');
          this.getLabelList();
        }
      });
    },
    // 取消
    cancelEdit () {
      this.closableHandle = false;
      this.getLabelList();
    },
    reomveType (arr) {
      this.deleteDialog = true;
      this.groupArr = arr;
    },
    reomveZiLabel (tagId) {
      this.customerPortrait.map(item => {
        item.corpTags.map(Tags => {
          if (tagId === Tags.tagId) {
            item.corpTags.splice(item.corpTags.indexOf(Tags), 1);
          }
        });
      });
      // console.log('this.customerPortrait', this.customerPortrait);
    },
    // 删除分类弹窗提醒
    deleteTypeHandle () {
      this.customerPortrait.splice(this.customerPortrait.indexOf(this.groupArr), 1);
      this.deleteDialog = false;
    },
    // 添加标签弹窗
    addSelectLabel () {
      this.labelname = '';
      this.checkedIds = [];
      this.customerSelect = [];
      http.userAllList({mobile: this.mobile}).then((res) => {
        if (res.success) {
          this.labelVisible = true;
          if (res.data.length > 0) {
            res.data.map(child => {
              child.corpTags.map(item => {
                if (item.isSelect === '1') {
                  this.checkedIds.push(item.tagId);
                }
              });
            });
          }
          this.customerSelect = res.data;
        }
      });
    },
    // 添加弹窗保存操作
    addNewSubmit () {
      this.labelVisible = false;
      let ids = [];
      this.checkedIds.map(item => {
        ids.push(item.tagId);
      });
      const params = {
        tagIds: ids,
        mobile: this.mobile
      };
      http.addUserLabelSave(params).then((res) => {
        if (res.success) {
          this.$message.success('添加成功!');
          // this.labelVisible = false;
          this.getLabelList();
        }
      });
    },
    // 添加弹窗取消操作
    addNewCancel () {
      this.labelVisible = false;
      this.checkedIds = [];
    },
    // 搜索标签
    searchName () {
      console.log(this.labelname, this.labelname !== '');
      if (this.labelname !== '') {
        http.userFilterList({mobile: this.mobile, name: this.labelname}).then((res) => {
          if (res.success) {
            this.checkedIds = [];
            this.customerSelect = [];
            if (res.data.length > 0) {
              res.data.map(child => {
                child.corpTags.map(item => {
                  if (item.isSelect === '1') {
                    this.checkedIds.push(item);
                  }
                });
              });
            }
            this.customerSelect = res.data;
            console.log('this.checkedIds', this.checkedIds);
          }
        });
      } else {
        this.addSelectLabel();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#customerCarInfo{min-width: 800px; margin-left: 330px;}
.opretaBtn{min-width: 800px;border-bottom:1px solid #eeeeee;padding-bottom:5px;display:flex;justify-content: space-between;align-items: center;flex-direction: row;}
.container{padding: 10px;}
.el-tag{margin-right:8px; margin-bottom:5px;}
.tagTitle{margin-bottom:10px; margin-top:10px;}
.costomerChunk{
  max-height:600px;
  overflow-y: scroll;
}
.el-checkbox {margin-right: 10px;}
.el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin:0;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/customerCheck/customerLabel.vue